import React, { Component } from "react";
import GolfUpdateForm from "./GolfUpdateForm";
import SendMessageScreen from "./SendMessageScreen";
import SentMessagesTable from "./SentMessagesTable";
import GolfStatusLogTable from "./GolfStatusLogTable";
import MembersForm from "./MembersForm";
import GolfStatusPage from "./GolfStatusPage";

class EBSHTower extends Component {
  render() {
    if (this.props.user.includes("lvzc.be")) {
      return <GolfStatusPage />;
    }

    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    var today  = new Date();
    let today_string = today.toLocaleDateString("en-GB").replace('/','-').replace('/','-');
    let tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    let tomorrow_string = tomorrow.toLocaleDateString("en-GB").replace('/','-').replace('/','-');

    return (
      <div>
        <nav>
          <div
            className="nav nav-tabs justify-content-center"
            id="nav-tab"
            role="tablist"
          >
            <a
              className="nav-item nav-link active"
              id="nav-golfstatus-tab"
              data-toggle="tab"
              href="#nav-golfstatus"
              role="tab"
              aria-controls="nav-golfstatus"
              aria-selected="true"
            >
              Update Golf Status
            </a>
            <a
              className="nav-item nav-link"
              id="nav-sendmessage-tab"
              data-toggle="tab"
              href="#nav-sendmessage"
              role="tab"
              aria-controls="nav-sendmessage"
              aria-selected="true"
            >
              Send Message
            </a>
            {<a
              className="nav-item nav-link"
              id="nav-golfstatuslog-tab"
              data-toggle="tab"
              href="#nav-golfstatuslog"
              role="tab"
              aria-controls="nav-golfstatuslog"
              aria-selected="false"
            >
              History
            </a>}
            <a
              className="nav-item nav-link"
              id="nav-log-tab"
              data-toggle="tab"
              href="#nav-log"
              role="tab"
              aria-controls="nav-log"
              aria-selected="false"
            >
              Message Log
            </a>
            <a
              className="nav-item nav-link"
              id="nav-members-tab"
              data-toggle="tab"
              href="#nav-members"
              role="tab"
              aria-controls="nav-members"
              aria-selected="false"
            >
              Members
            </a>
            <a
              className="nav-item nav-link"
              id="nav-contact-tab"
              data-toggle="tab"
              href="#nav-contact"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false"
            >
              Contact
            </a>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-golfstatus"
            role="tabpanel"
            aria-labelledby="nav-golfstatus-tab"
          >
            <div className="container">
              <div className="row justify-content-center p-3">
                <div className="col-sm">
                  <GolfUpdateForm user={this.props.user} today={today_string} tomorrow={tomorrow_string}/>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-sendmessage"
            role="tabpanel"
            aria-labelledby="nav-sendmessage-tab"
          >
            <div className="container">
              <div className="row justify-content-center p-3">
                <div className="col-sm">
                  <SendMessageScreen user={this.props.user} />
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-log"
            role="tabpanel"
            aria-labelledby="nav-log-tab"
          >
            <div className="container">
              <div className="row justify-content-center p-3">
                <div className="col-sm">
                  <h3>Message Log</h3>
                  <SentMessagesTable />
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="nav-golfstatuslog"
            role="tabpanel"
            aria-labelledby="nav-golfstatuslog-tab"
          >
            <GolfStatusLogTable />
          </div>
          <div
            className="tab-pane fade"
            id="nav-members"
            role="tabpanel"
            aria-labelledby="nav-members-tab"
          >
            <div className="container">
              <div className="row justify-content-center p-3">
                <div className="col-sm">
                  <h3>Member Status</h3>
                  <MembersForm />
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="nav-contact"
            role="tabpanel"
            aria-labelledby="nav-contact-tab"
          >
            <table className="table table-striped table-sm">
            <tr>
              <td>Question/Contact</td><td>Bertrand Fontaine</td><td>Bertrand@lesfontaines.be</td>
            </tr>
            <tr>
              <td>Developer</td><td>Lode Spruyt</td><td>lode.spruyt@gmail.com</td>
            </tr>
            <tr>
              <td>President</td><td>Olivier Georis</td><td>Olivier.Georis@skynet.be</td>
            </tr>
            </table>


          </div>
        </div>
      </div>
    );
  }
}

export default EBSHTower;
